import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

var config = {
    apiKey: "AIzaSyDqw_4VXImJjGfF_xcthRc0m0hCx3hbs2U",
    authDomain: "houseparty-cc97c.firebaseapp.com",
    databaseURL: "https://houseparty-cc97c.firebaseio.com",
    projectId: "houseparty-cc97c",
    storageBucket: "houseparty-cc97c.appspot.com",
    messagingSenderId: "283834176582"
  };
  firebase.initializeApp(config);
  firebase.firestore().settings({ timestampsInSnapshots: true});

  export default firebase;